import {Component, OnInit} from '@angular/core';
import {MdbButtonComponent} from "../../../../utils/mdb-button/mdb-button.component";
import {ApiInterfaceFormComponent} from "../../../../forms/api-interface-form/api-interface-form.component";
import {AConcreteResource} from "../../../../AConcreteResource";
import {ApiInterfaceModel} from "../../../../../models/resources/api-interface.model";
import {FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {ApiInterfaceService} from "../../../../../services/resources/api-interface.service";
import {HttpErrorsService} from "../../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../../services/utils/custom-notification.service";
import {SafeUpdateService} from "../../../../../services/utils/safe-update.service";
import {finalize} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-api-interface-data',
  imports: [
    MdbButtonComponent,
    ApiInterfaceFormComponent
  ],
  templateUrl: './api-interface-data.component.html',
  styleUrl: './api-interface-data.component.scss',
})
export class ApiInterfaceDataComponent extends AConcreteResource<ApiInterfaceModel> {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    router: Router,
    private apiInterfaceService: ApiInterfaceService,
    private httpErrorsService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
  ) {
    super(router, apiInterfaceService);
  }

  submit(serverResource: any = null, overrideValues: { [key: string]: any } = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = {...this.formGroup?.value};

    resource.updatedAt = this.model()!.updatedAt;

    if (serverResource) {
      resource = this.safeUpdateService.handleResource(resource, serverResource, overrideValues);
    }

    this.apiInterfaceService
      .update(this.model()!.id, resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED');
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorsService.handleError(e, (newServerResource, newOverrideValues) => {
            this.submit(newServerResource, newOverrideValues);
          });
        },
      });
  }
}
